'use strict';

export default {
  methods: {
    getDocumentos: function (group = false) {
      this.$service.get('documentos')
        .then(response => {
          if (response) {
            if (group) {
              let documentos = response;
              let items = {};
              documentos.map(item => {
                let key = `${item.entidad_nombre} (${item.entidad_sigla})`;
                if (!items[key]) {
                  items[key] = [];
                }
                items[key].push(item);
              });
              this.docs = response;
              this.documentos = items;
            } else {
              this.docs = response;
              this.documentos = response;
            }
          }
        });
    },
    getEntidades: function () {
      this.$service.get('documentos')
        .then(response => {
          if (response) {
            let documentos = response;
            let itemsIndices = [];
            let items = [];
            for (let i = 0; i < documentos.length; i++) {
              if (!itemsIndices.includes(parseInt(documentos[i].entidad_codigo_portal))) {
                itemsIndices.push(parseInt(documentos[i].entidad_codigo_portal));
                items.push({
                  entidad_nombre: documentos[i].entidad_nombre,
                  entidad_codigo_portal: documentos[i].entidad_codigo_portal,
                  entidad_sigla: documentos[i].entidad_sigla
                });
              }
            }

            this.entidades = items.sort((a, b) => (a.entidad_nombre > b.entidad_nombre) ? 1 : ((b.entidad_nombre > a.entidad_nombre) ? -1 : 0));
          }
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/pages/mixins/documentos.js